export default __webpack_public_path__ + "static/B0111-a5e2ceca6801605b21bd09c1d0e14f36.png";